import axios from 'axios';

let AxiosManager = function () {
    function _axiosRequest(method, url, params, data, responseType, sucessCallback, failureCallback) {
        method = method ?? 'get';
        responseType = responseType ?? 'json';

        axios({
            method,
            url,
            responseType,
            data
        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.error(error.response.data);
                console.error(error.response.status);
                console.error(error.response.headers);

                failureCallback(generateResultErrorMessage("serverError", url));
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.error(error.request);

                failureCallback(generateResultErrorMessage("noResponse", url));
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error', error.message);

                failureCallback(generateResultErrorMessage("requestConfig", url));
            }

            console.error(error.config);
            console.error(error.toJSON());
        })
        .then(res => res && sucessCallback(res))
    }

    return {
        AxiosRequest: function (method, url, params, data, responseType, sucessCallback, failureCallback) {
            return _axiosRequest(method, url, params, data, responseType, sucessCallback, failureCallback);
        }
    }
}

function generateResultErrorMessage(tipoError, endpoint) {
    let mensaje = "";

    switch (tipoError) {
        case "requestConfig": {
            mensaje = "Ocurrió un error de configuración de la request. Comunicarse con soporte y volver a intentarlo más tarde. (" + endpoint + ")"
        }
            break;
        case "serverError": {
            mensaje = "Ocurrió un error de comunicación con el servidor. Comunicarse con soporte y volver a intentarlo más tarde. (" + endpoint + ")"
        }
            break;
        case "noResponse": {
            mensaje = "No se obtuvo respuesta del lado del servidor. Comunicarse con soporte y volver a intentarlo más tarde. (" + endpoint + ")"
        }
            break;
    };

    return mensaje;
}

let axiosManager = new AxiosManager();
export default axiosManager;